import { createContext, useContext } from 'react'
import { Formik } from 'formik'
import { v4 as uuidv4 } from 'uuid'

// Initial form values

const FormContext = createContext()

export const FormProvider = ({ children, onSubmit }) => {
  const initialValues = {
    id: uuidv4(),
    name: '',
    email: '',
    review: ''
  }
  return (
    <Formik
      initialValues={initialValues}
      onSubmit={async (values, { setSubmitting }) => {
        try {
          await onSubmit(values)
        } catch (error) {
          console.error('Error submitting form:', error)
        } finally {
          setSubmitting(false)
        }
      }}
    >
      {({ values, errors, touched, handleChange, handleBlur, setFieldValue, handleSubmit }) => (
        <FormContext.Provider
          value={{
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            setFieldValue,
            handleSubmit
          }}
        >
          {children}
        </FormContext.Provider>
      )}
    </Formik>
  )
}

export const useForm = () => {
  const context = useContext(FormContext)
  if (!context) {
    throw new Error('useForm must be used within a FormProvider')
  }
  return context
}
